module.exports = __webpack_public_path__ + "img/expense_photo_default.9cbb1f7.jpg";